export function memberDisplayName(member) {
    const user = member?.user || {};
    const full = `${user.first_name || ""} ${user.last_name || ""}`.trim();
    return full || user.phone_number || user.username || "—";
}

export function memberInitials(name) {
    const parts = String(name || "")
        .trim()
        .split(/\s+/)
        .filter(Boolean);
    if (!parts.length) return "—";
    return parts
        .slice(0, 2)
        .map((part) => part[0])
        .join("");
}

export function formatCount(value, locale = "fa-IR") {
    return Number(value || 0).toLocaleString(locale);
}

export function formatPercent(value, locale = "fa-IR") {
    if (value == null || value === "") return "—";
    const number = Number(value);
    if (!Number.isFinite(number)) return "—";
    return number.toLocaleString(locale, { maximumFractionDigits: 1 });
}

export function formatNps(value, locale = "fa-IR") {
    if (value == null || value === "") return "—";
    const number = Number(value);
    if (!Number.isFinite(number)) return "—";
    const digits = Math.abs(number).toLocaleString(locale);
    if (number > 0) return `+${digits}`;
    if (number < 0) return `−${digits}`;
    return digits;
}

export function formatPhone(value) {
    if (!value) return "—";
    return String(value);
}

export function downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
}

export function clubMemberQuery(search, userGroupId) {
    const params = {};
    if (search) params.search = search;
    if (userGroupId) params.user_group = userGroupId;
    return params;
}
